<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BcDUpK/tc-custom/9781788632157.jpg?1726519109682" alt="This image is the cover for the book Quincunx: The Palphramonds, The Quincunx"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Quincunx: The Palphramonds, The Quincunx
      </h1>
      <p class="bookDescription body article font2">
        <p>A classic Victorian mystery full of intrigue, deadly plots and devastating twists and turns</p><p>Falsely imprisoned in an asylum, <b>John</b> escapes from their clutches with the help of the kindly Digweed family. Starting a new life in hiding with them may feel safer, but they survive by scavenging the sewers of London.</p><p>Summoning his strength, and on discovering the existence of a second will that could be his salvation, John must go undercover in the guise of a servant, into the very heart of the enemy themselves…</p><p><b>The fourth part of the classic and beloved <i>The Quincunx</i> is perfect for fans of Michel Faber and S.J. Parris.</b></p><p>Praise for <i>The Quincunx</i></p><p>‘<b>Grips like steel</b>… it’s a book to make you miss your stop on the bus or the train, keep you up at night and wake you early… a formidable achievement’ <i>Kaleidoscope</i>, BBC Radio 4</p><p>‘His <b>brilliant</b> and entertaining pastiche of the mid-nineteenth-century novel’ <i>The Times</i></p><p>‘A brilliant and deeply eccentric attempt to reproduce an early Victorian novel…it combines massive scope with minute detail – there is a cast of thousands, but every figure is loveingly painted. The plot is so thick the spoon stands up in it, and by the end, the reader has toured the whole of late Regency society… <b>Magnificent – gripping and beautifully written</b>; the sort of book that sends you into a trance of pleasure’ <i>Independent</i></p><p>‘Charles Palliser has realised a world that can almost be smelt and tasted as it pours off the page of this <b>gripping, extraordinary novel</b>’ <i>Daily Telegraph</i></p><p>‘His plot is of an intricacy that Wilkie Collins himself might have envied… <b>an astonishing achievement</b>’ <i>Scotsman</i></p>The Quincunx<p>1 The Huffams</p><p>2 The Mompessons</p><p>3 The Clothiers</p><p>4 <b>The Palphramonds</b></p><p>5 The Maliphants</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Charles Palliser
      </h2>
      
      <p class="authorDescription body article"><P>Charles Palliser is a best-selling novelist, American-born but British-based. His most well-known novel, The Quincunx, now published by Canelo in five Parts, has sold over a million copies internationally, and was awarded the Sue Kaufman Prize for First Fiction in 1991. He has published five novels that have been translated into a dozen languages, and also written for theatre, radio, and television.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canelo Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?302e6394